var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeslizamiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#626362;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "flqKoe_00000139979841271386034950000012591632992000944556_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,103.1c5.8,0.3,15.7-2.3,18-5.3C34.7,98.1,28.7,99.4,23.2,103.1z M148.5,93.4 c-6.7-0.2-16.4,2.8-17.8,5.4C137.1,98.4,143.1,97.1,148.5,93.4z M58.8,98.2c-1.6-4.9-5.9-7.3-10.9-9.1 C47.9,92.9,53.6,97.2,58.8,98.2z M124.1,107.2c-0.3-4-6.1-7.9-10.7-8.9C113.6,102,119.4,106.1,124.1,107.2z M156.9,111.8 c-0.3-4.1-7.1-8.4-10.9-9.1C146.7,106.3,151.3,110.2,156.9,111.8z M130.9,62.1c-0.4,3.1,5.4,8.1,10.8,9 C140.1,66.3,135.9,63.9,130.9,62.1z M165.6,94c0.1-3.7-6.4-8.5-10.9-9.2C156.2,89.7,160.7,91.9,165.6,94z M65.3,53.1 c-0.1,3.4,6,8.5,10.8,9.1C74.6,57.3,70.3,54.9,65.3,53.1z M115.8,88.9c-6.6-0.1-15.7,2.6-17.7,5.3 C104.4,93.8,110.3,92.5,115.8,88.9z M82,55c6.4-0.2,12.3-1.4,17.2-5C92.9,50.1,87,51.4,82,55z M39.1,107.2 c0.3,3.5,6.5,8.7,10.8,8.9C49.1,112.3,43.9,108.1,39.1,107.2z M41.1,67c5.8,0.3,15.2-2.5,17.3-5.1C52.9,61.6,44.5,64,41.1,67z  M106.5,76.1c6.7-0.4,12.6-1.6,17.9-5.3C117.3,70.9,110,73.1,106.5,76.1z M122,80c0.6,3.9,6.5,8.7,11,9.1 C131.4,84.3,127.1,81.9,122,80z M97.9,125c-6.3,0.2-12.3,1.4-17.2,5C87.1,129.9,92.9,128.6,97.9,125z M139.6,80.4 c6.3-0.2,12.3-1.4,17.2-5C150.5,75.6,144.6,76.8,139.6,80.4z M121.9,116.7c6.6-0.3,12.5-1.6,17.7-5.2 C134.2,111.1,125.4,113.6,121.9,116.7z M104.6,116.3c0.6,3.8,6,8.2,10.8,8.9C115.2,121.8,110.1,117.7,104.6,116.3z M91.4,66.4 c-5.5-0.2-14.9,2.2-17.2,5.1C79.8,71.7,88.1,69.3,91.4,66.4z M106.5,107c-6.3,0.2-12.2,1.4-17,5 C95.8,111.8,101.6,110.6,106.5,107z M56.6,71.3c0,3.1,5.4,7.6,10.7,8.9C67.1,76.8,61.6,72.3,56.6,71.3z M34.5,75.6 c-0.2-3.3-5.6-7.7-10.7-8.9C23.8,69.8,28.9,74.4,34.5,75.6z M82.6,120.7c-0.2-3.1-4.9-7.5-10.7-8.9 C71.9,115,77.3,119.6,82.6,120.7z M15,84.5c0.5,3.9,6.3,8.6,10.9,9.1C24.4,88.8,20.1,86.5,15,84.5z M82.5,84.5 c-6.3,0.2-12.2,1.4-17.1,4.9C71.7,89.3,77.5,88,82.5,84.5z M49.7,80c-6.3,0.2-12.2,1.4-17.1,5C38.9,84.8,44.8,83.5,49.7,80z  M73.7,102.5c-6.3,0.1-12.2,1.4-17.1,4.9C62.9,107.4,68.7,106.1,73.7,102.5z M65.3,120.4c-6.6,0.3-12.5,1.6-17.8,5.2 C53.5,125.9,61.8,123.4,65.3,120.4z M91.5,102.9c-0.8-4.1-6.4-8.6-11-9.1C82,98.7,86.3,101,91.5,102.9z M97.9,57.6 c0.7,3.9,6.6,8.7,10.9,8.9C107.9,62.7,103.4,59,97.9,57.6z M132,54.5c-6.3,0.2-12.2,1.4-17.1,5C121.1,59.3,127,58,132,54.5z  M89.2,75.5c0.8,4.1,6.8,8.9,11,9.1C98.6,79.8,94.3,77.4,89.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,103.1c5.6-3.7,11.5-5,18-5.3C38.9,100.8,29,103.4,23.2,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.5,93.4c-5.5,3.7-11.4,5-17.8,5.4C132.2,96.2,141.8,93.2,148.5,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.8,98.2c-5.1-1-10.8-5.4-10.9-9.1C52.8,91,57.1,93.3,58.8,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.1,107.2c-4.7-1.1-10.5-5.3-10.7-8.9C118,99.3,123.8,103.2,124.1,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.9,111.8c-5.6-1.6-10.3-5.5-10.9-9.1C149.9,103.4,156.6,107.7,156.9,111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.9,62.1c4.9,1.9,9.2,4.2,10.8,9C136.4,70.1,130.5,65.2,130.9,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.6,94c-4.9-2.1-9.4-4.3-10.9-9.2C159.2,85.4,165.8,90.3,165.6,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.3,53.1c5,1.9,9.2,4.2,10.8,9.1C71.3,61.5,65.2,56.5,65.3,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.8,88.9c-5.4,3.7-11.4,4.9-17.7,5.3C100.1,91.5,109.1,88.8,115.8,88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,55c5-3.6,10.9-4.8,17.2-5C94.3,53.5,88.4,54.8,82,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,107.2c4.8,0.8,10,5.1,10.8,8.9C45.6,115.9,39.3,110.7,39.1,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,67c3.4-2.9,11.7-5.4,17.3-5.1C56.3,64.5,47,67.3,41.1,67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,76.1c3.6-3.1,10.8-5.2,17.9-5.3C119.1,74.6,113.2,75.7,106.5,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,80c5.1,1.9,9.4,4.2,11,9.1C128.6,88.8,122.7,83.9,122,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,125c-5,3.6-10.9,4.8-17.2,5C85.7,126.4,91.6,125.2,97.9,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.6,80.4c4.9-3.6,10.9-4.8,17.2-5C151.9,79,146,80.2,139.6,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.9,116.7c3.4-3,12.3-5.6,17.7-5.2C134.4,115.1,128.6,116.3,121.9,116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.6,116.3c5.5,1.4,10.6,5.6,10.8,8.9C110.6,124.4,105.3,120,104.6,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.4,66.4c-3.2,2.9-11.6,5.4-17.2,5.1C76.5,68.6,85.8,66.2,91.4,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,107c-4.9,3.6-10.8,4.8-17,5C94.4,108.4,100.2,107.2,106.5,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.6,71.3c5,1.1,10.6,5.5,10.7,8.9C61.9,79,56.5,74.4,56.6,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,75.6c-5.6-1.2-10.7-5.8-10.7-8.9C28.9,67.9,34.3,72.3,34.5,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,120.7c-5.3-1.1-10.7-5.7-10.7-8.9C77.7,113.2,82.4,117.5,82.6,120.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,84.5c5.1,2,9.4,4.2,10.9,9.1C21.3,93.1,15.5,88.5,15,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.5,84.5c-5,3.6-10.8,4.8-17.1,4.9C70.3,85.9,76.2,84.6,82.5,84.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,80c-5,3.6-10.8,4.8-17.1,5C37.5,81.3,43.4,80.1,49.7,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.7,102.5c-5,3.6-10.8,4.8-17.1,4.9C61.5,104,67.4,102.6,73.7,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.3,120.4c-3.6,3.1-11.8,5.5-17.8,5.2C52.9,121.9,58.7,120.7,65.3,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,102.9c-5.1-1.9-9.4-4.2-11-9.1C85,94.3,90.6,98.9,91.5,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,57.6c5.5,1.4,9.9,5.1,10.9,8.9C104.6,66.3,98.7,61.5,97.9,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132,54.5c-4.9,3.6-10.8,4.8-17.1,5C119.7,55.9,125.6,54.6,132,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.2,75.5c5.1,1.9,9.4,4.2,11,9.1C96,84.4,90.1,79.6,89.2,75.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.6,139.1L88.6,139.1c-19.4-0.2-37.2-3.5-52.9-10c-10.3-4.2-18.3-9.3-24.3-15.5c-8.2-8.4-11.8-17-10.9-26.3 c0.8-8,4.6-15.2,11.8-22c7.4-7,17-12.5,29.6-16.9c11.8-4.1,24.5-6.5,37.7-7.3c20.6-1.2,38.8,1,55.8,6.4 c13.7,4.4,24.3,10.2,32.3,17.8c8.9,8.4,12.7,17.4,11.8,27.3c-0.6,6.5-3.4,12.6-8.5,18.5c-7.9,9.1-18.9,15.7-34.6,20.9 C121.9,136.9,106.8,139.1,88.6,139.1L88.6,139.1z M90.2,43.9c-3.5,0-7.1,0.1-10.7,0.3c-12.9,0.7-25.3,3.2-36.8,7.3 C31,55.8,21.9,61.2,15,67.9C8.8,74,5.5,80.3,4.9,87.2c-0.7,8,2.3,15.5,9.4,22.9c5.6,5.8,12.9,10.7,22.6,14.8 c15.3,6.5,32.7,9.9,51.7,10c17.9-0.1,32.8-2.3,46.8-7.1c14.9-5.1,25.2-11.5,32.4-20.1c4.4-5.2,6.7-10.5,7.3-16 c0.7-8.5-2.5-16.3-10.1-23.8c-7.4-7.3-17.4-12.9-30.4-17.2C120.8,46.1,106.3,43.9,90.2,43.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeslizamiento);
export default __webpack_public_path__ + "static/media/deslizamiento.b69533ba49b628117e5174704fb3346f.svg";
export { ForwardRef as ReactComponent };